import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';

// services
import { AssetsService } from './assets.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class AssetsServiceModule {
  static forRoot(): ModuleWithProviders<AssetsServiceModule> {
    return {
      ngModule: AssetsServiceModule,
      providers: [AssetsService],
    };
  }
}
